import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteReport } from "../../api/reports";

export function useDeleteReport() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteReport,
    onSuccess: () => {
      console.log("Report deleted successfully");
      queryClient.invalidateQueries({ queryKey: ["reports"] });
    },
    onError: (err) => console.error("Error deleting report:", err),
  });
}
